import _jsx from '@babel/runtime/helpers/jsx';
import 'react';
import 'prop-types';
import Card, { CardContent } from '@andes/card';
import { Pill } from '@andes/badge';
import { Image } from 'frontend-image';
import { jsx, Fragment } from 'react/jsx-runtime';
const CardBlogEntryMobile = props => {
  const {
    blog,
    jsDisabled,
    preload,
    showImage,
    insideCarousel,
    supportWebP,
    mounted,
    tagsToFilter
  } = props;
  const {
    title,
    url,
    image,
    description,
    tags,
    tags_metadata
  } = blog;
  const isTagProvided = tags && tags.length > 0;
  const filterTags = () => {
    const upperCaseTagsToFilter = tagsToFilter.map(tag => tag.toUpperCase());
    if (isTagProvided) {
      const upperCaseTags = tags ? tags.map(tag => tag.toUpperCase()) : [];
      return upperCaseTags.filter(tag => !upperCaseTagsToFilter.includes(tag));
    }
    const upperCaseTagsDetail = tags_metadata ? tags_metadata.map(tagDetail => {
      return {
        name: tagDetail.name.toUpperCase(),
        url: tagDetail.url
      };
    }) : [];
    return upperCaseTagsDetail.filter(tagDetail => !upperCaseTagsToFilter.includes(tagDetail.name));
  };
  const sanitizedTags = filterTags();
  const namespace = 'seo-ui-card-blog-entry-mobile';
  const onLoad = (() => {
    if (jsDisabled) {
      return 'off';
    }
    return !(preload && showImage) ? 'on' : 'off';
  })();
  const updateImageUrl = () => {
    let modifiedUrl = image.url.replace('http://', 'https://').replace(/-[a-zA-Z][a-zA-Z].jpg/, '-V.jpg').replace(/ml[a-zA-Z]-s[0-9]-p.mlstatic.com[/]/, 'http2.mlstatic.com/D_Q_NP_');
    if (supportWebP) {
      modifiedUrl = modifiedUrl.replace('.jpg', '.webp');
    }
    return modifiedUrl;
  };
  const updatedUrl = updateImageUrl();
  const BottomTagsComponent = _ref => {
    let {
      tags
    } = _ref;
    return isTagProvided ? /*#__PURE__*/_jsx("div", {
      className: `${namespace}-bottom-tags-container`
    }, void 0, tags.map(tag => /*#__PURE__*/_jsx(Pill, {
      size: "small",
      hierarchy: "quiet",
      className: `${namespace}-tag`
    }, tag, tag))) : /*#__PURE__*/_jsx("div", {
      className: `${namespace}-bottom-tags-container`
    }, void 0, tags.map(tagDetail => /*#__PURE__*/_jsx("a", {
      href: `${tagDetail.url}`
    }, void 0, /*#__PURE__*/_jsx(Pill, {
      size: "small",
      hierarchy: "quiet",
      className: `${namespace}-tag`
    }, tagDetail.name, tagDetail.name))));
  };
  const CardImage = () => insideCarousel ? /*#__PURE__*/_jsx(Image, {
    className: `${namespace}-image`,
    src: updatedUrl,
    fallbacksrc: image.url,
    alt: image.alt,
    mounted: mounted,
    preload: preload,
    lazyload: "on",
    carousel: true
  }) : /*#__PURE__*/_jsx(Image, {
    className: `${namespace}-image`,
    src: updatedUrl,
    fallbacksrc: image.url,
    preload: preload && showImage,
    lazyload: "off",
    onload: onLoad,
    alt: image.alt,
    fetchPriority: preload && showImage ? 'high' : null,
    mounted: mounted
  });
  return /*#__PURE__*/_jsx(Card, {
    className: `${namespace}-container`
  }, void 0, /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(CardContent, {
      className: `${namespace}-content-container`
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}-content-container-image`
    }, void 0, /*#__PURE__*/_jsx(CardImage, {})), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("div", {
      className: `${namespace}-container-top`
    }, void 0, /*#__PURE__*/_jsx("a", {
      href: url,
      className: `${namespace}-link`
    }, void 0, /*#__PURE__*/_jsx("h2", {
      className: `${namespace}-title`
    }, void 0, title)), /*#__PURE__*/_jsx("p", {
      className: `${namespace}-description`
    }, void 0, description)), /*#__PURE__*/_jsx("div", {
      className: `${namespace}-container-bottom`
    }, void 0, /*#__PURE__*/_jsx(BottomTagsComponent, {
      tags: sanitizedTags
    })))))
  }));
};
CardBlogEntryMobile.defaultProps = {
  insideCarousel: false,
  preload: undefined,
  showImage: true,
  tagsToFilter: []
};
CardBlogEntryMobile.displayName = 'CardBlogEntryMobile';
export { CardBlogEntryMobile as default };
